import type {
  StockTransformation,
  StockTransformationLine,
} from "@artisancode/api-types";

export function filterProductions(
  transformations: StockTransformation[],
  query: string,
  status: string,
): StockTransformation[] {
  const q = query.toLowerCase();
  return transformations.filter((t) => {
    if (status !== "all" && t.status !== status) return false;
    if (!q.trim()) return true;
    const menuNames = (t.lines ?? [])
      .filter((l) => l.direction === "output")
      .map((l) => l.itemName);
    return [t.code, ...menuNames, t.note].some((v) =>
      (v ?? "").toLowerCase().includes(q),
    );
  });
}

export interface ProductionMenu {
  outputLine: StockTransformationLine;
  inputLines: StockTransformationLine[];
  inputCost: number;
  unitCost: number;
}

/** A batch can make several menus; each one is costed from its own ingredient lines. */
export function summarizeProduction(t: StockTransformation) {
  const lines = t.lines ?? [];
  const inputLines = lines.filter((l) => l.direction === "input");
  const menus: ProductionMenu[] = lines
    .filter((l) => l.direction === "output")
    .map((outputLine) => {
      const menuInputs = inputLines.filter(
        (l) => l.outputLineId === outputLine.id,
      );
      const inputCost = menuInputs.reduce(
        (sum, l) => sum + l.qty * l.unitCost,
        0,
      );
      const unitCost =
        outputLine.unitCost > 0
          ? outputLine.unitCost
          : outputLine.qty > 0
            ? inputCost / outputLine.qty
            : 0;
      return { outputLine, inputLines: menuInputs, inputCost, unitCost };
    });
  // Gunakan totalInputCost eksak dari dokumen jika tersedia
  const totalInputCost =
    t.totalInputCost ?? menus.reduce((sum, m) => sum + m.inputCost, 0);
  const menuNames = menus.map((m) => m.outputLine.itemName).join(", ");

  return { menus, inputLines, totalInputCost, menuNames };
}
